import { PropTypes } from "prop-types"
import isTouchDevice from "is-touch-device"

import Translate from "../Translate"

const ClearButton = ({ onClick, showClearButton, ...rest }) => {
  const handleKeyPress = e => {
    if (e.key === "Enter" || e.key === "Space") {
      onClick(e)
    }
  }

  return isTouchDevice() || showClearButton ? (
    <Translate>
      {({ translate }) => (
        <button
          className="oj-clear-button"
          type="button"
          aria-label={translate("accessClearButtonLabel")}
          onClick={onClick}
          onKeyDown={handleKeyPress}
          {...rest}
        />
      )}
    </Translate>
  ) : null
}

ClearButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  showClearButton: PropTypes.bool
}

export default ClearButton
